import { format } from 'date-fns/esm'
import { computed, makeObservable, observable } from 'mobx'

import { EMPTY_NUMBER_ID } from '@/constant/common'
import { DTO } from '../DTO'

export class ParentsAppNotice extends DTO {
  id = EMPTY_NUMBER_ID
  type: res.ParentsAppNotice['type'] = 'NOTICE'
  teacherName = ''
  title = ''
  content = ''
  marked = false
  createDatetime = new Date()

  constructor(data?: res.ParentsAppNotice) {
    super()

    makeObservable(this, {
      id: observable,
      type: observable,
      teacherName: observable,
      title: observable,
      content: observable,
      marked: observable,
      createDatetime: observable,
      date: computed,
    })

    if (data) {
      this.id = data.id
      this.type = data.type
      this.teacherName = data.teacherName
      this.title = data.title
      this.content = data.content
      this.marked = data.marked
      this.createDatetime = new Date(data.createDatetime)
    }
  }

  get date() {
    return format(this.createDatetime, 'yy.MM.dd')
  }
}
